<ul
    [id]="getWidgetId"
    class="accordion-root"
    [class.mobileWidgetViewWrap]="isDeviceMobile$ | async"
    [class.tabletWidgetViewWrap]="isDeviceTablet$ | async"
    [style.--accordion-transform]="rootTransform()"
    [style.--accordion-transform-mobile]="rootTransformMobile()"
    [style.--accordion-transform-tablet]="rootTransformMobile()"
    [style.--accordion-z-index]="rootZIndex()"
    [style.--accordion-z-index-mobile]="rootZIndexMobile()"
    [style.--accordion-z-index-tablet]="rootZIndexMobile()"
>
    @for (accordionItem of accordionList(); track $index; let i = $index) {
        <li
            class="parent-item accordion-item"
            [class.accordion-indent]="form.isIndent().value()"
            [style.--accordion-divider-color]="dividerColor()"
        >
            <div
                class="accordion-item-title"
                [class.accordion-icon-right]="form.horizontalAlign().value() === iconPosition.R"
                [class.accordion-icon-left]="form.horizontalAlign().value() === iconPosition.L"
            >
                <div class="accordion-item-title-content sp-ui-text">
                    <web-editor
                        class="sp-editor"
                        [useExperimentalFocus]="true"
                        [containerId]="containerId"
                        [widgetId]="widgetIdValue"
                        [content]="accordionItem.title"
                        [isPasteAsText]="true"
                        (changeContent)="saveAccordionData($event, 'title', i)"
                    />
                </div>
                <div
                    class="accordion-control accordion-icon itemControl_{{ i }}"
                    [style.--accordion-icon-color]="iconColor()"
                    [class.active]="i === lastOpenItem"
                    [class.accordion-icon-plus]="form.iconType().value() === iconStyle.PLUS"
                    [class.accordion-icon-caret]="form.iconType().value() === iconStyle.CARET"
                    (click)="toggleItem(i)"
                ></div>
            </div>
            <div
                class="accordion-item-title-content itemContent_{{ i }} sp-ui-text accordion-animation"
                [class.active]="i === 0"
                [style.height]="i === 0 ? 'auto' : '0'"
            >
                <web-editor
                    class="sp-editor"
                    [useExperimentalFocus]="true"
                    [containerId]="containerId"
                    [widgetId]="widgetIdValue"
                    [content]="accordionItem.content"
                    [isPasteAsText]="true"
                    (changeContent)="saveAccordionData($event, 'content', i)"
                />
            </div>
        </li>
    }
</ul>
